export const formCb = {};

export const contentTypeMap = {
  1: "dk_hasPgTable", // 有dataKey并且有分页的表格
  2: "noPgTable", // 没有dataKey和分页的表格
  3: "Tree", // 常用树形
  4: "hasPgTable", // 没有dataKey有分页的表格
  5: "hrmTable", // 人力列表
  6: "hrmTree", // 人力组织树
  7: "hrmTreeGroup" // 人力常用组
};

export const orgInfoArr = ["4", "57", "167", "168", "164", "194", "169", "170"];

export const initialState = {
  showSearchAd: false, // 是否显示高级搜索下拉框
  browserConditions: [], // 浏览按钮配置
  loadAllTreeData: false,
  count: 0, // 数据总数
  current: 1, // 数据页码
  inputValue: "", // 快速搜索 值
  date2during: "", // 下拉框选中值
  contentType: "", // 返回查询数据类型
  isAccount: false, // 人力资源有无账号人员
  checkStrictly: true, // 组织维度是否包含下级
  showAllbranch: false, // 人力资源有无下级
  leftCheckedData: [], // 穿梭框左侧点选数据
  rightCheckedData: [], // 穿梭框右侧点选数据
  leftTreeCheckedKeys: [], // 左侧树选中节点
  leftTreeCheckedData: [], // 左侧树选中节点
  leftGroupCheckedKeys: [], // 左侧树选中节点
  leftGroupCheckedData: [], // 左侧树选中节点
  leftExpandKeys: [], // 左侧树选中受控
  leftSelectKeys: [] // 左侧树展开受控
};

export const defaultProps = {
  // 主要属性
  dataURL: "/api/public/browser/data/",
  conditionURL: "/api/public/browser/condition/",
  destUrl: "/api/public/browser/destData/",
  leftTreeUrl: "/api/public/browser/data/", // 左侧树url
  tabsUrl: "/api/common/browser/tab/list?type=", // 请求tabs路由
  type: "7", // 字段的类型，对应 workflow_billfield 表中的 type 字段
  viewAttr: 2, // 显示属性 1(只读) 2(可编辑) 3(必填)
  icon: "icon-toolbar-Organization-list", // 浏览框标题图标类名
  iconBgcolor: "#4a90e2", // 浏览框标题图标背景色
  iconFontColor: "#fff", // 浏览框标题图标颜色
  topPrefix: "wea",
  desc: "", // 浏览按钮的中文描述
  fieldName: "", // 浏览按钮的名称，在表单中是字段的ID
  // 开关属性
  isSingle: true, // 是否单选; true:单选 false:多选
  hasRadio: false, // 流程导入按钮 true
  hideOps: false, // 是否隐藏放大镜
  showCheckStrictly: true, // 显示控制 checkStrictly 属性的按钮
  hasScroll: true, // 输入框默认显示美化滚动条
  isDetail: "", // 字段类型，主表字段最小宽度为 230px，明细字段最小宽度为 120px
  isLoadAll: false,
  isAutoComplete: 0, // 是否自动提示 默认值:否;
  memorise: false, // customized 为 true，默认不记忆右侧的选中数据
  scrollx: false, // 单选浏览 table 是否显示横向滚动条
  noOperate: true, // 浏览按钮 table 是否显示操作列， 默认不显示
  needCallDest: true, // 已选列表是否走接口
  // 接口属性
  linkUrl: "", // 浏览按钮显示值对应的链接地址
  dataParams: {}, // dataURL 默认参数
  conditionDataParams: {}, // 条件接口默认参数
  completeParams: {}, // completeURL 默认参数
  leftTreeParams: { datatype: "tree" }, // 左侧树leftTreeUrl 默认参数
  tabsParams: {}, // 请求tabs接口参数
  // 样式属性
  inputStyle: {}, // 输入框的样式 宽度等
  modalStyle: { width: 784 }, // 浏览框样式
  contentHeight: 460,
  // 添加按钮
  hasAdd: false, // 是否显示快捷添加的按钮，true：显示 false：不显示
  ddUrl: "", // 添加按钮对应的链接地址
  addOnClick: "", // 单击添加按钮时触发的onclick事件
  onChange: "" // 回调函数
};

export const defaultState = {
  ...initialState,
  visible: false, // 弹框显隐
  loading: true, // 数据加载状态
  data: [], // 受控选中数据
  modalloaded: false, // modal 加载完成
  activeKey: "", // tabKey
  quickSearch: "", // 高级搜索 快速搜索 key
  selectedData: [], // 已选列表
  inputId: "id", // 接口数据主键
  inputName: "name", // 接口数据显示主键
  inputTop: [],
  inputBottom: [],
  columns: [], // 表头
  tabsFromApi: [], // 从tabsUrl接口中获取到的tabs
  dataKey: "", // tablestring 分页数据 dataKey
  dataOfListWithkey: [], // tablestring 分页列表
  dataOfListWithoutKeyAndPg: [], // 普通不分页非 key 列表
  dataOfListWithoutKeyButPg: [], // 自定义分页列表
  dataIconBgColor: "", // 数据 icon 背景
  dataIconFontColor: "", // 数据 icon
  idCache: "",
  nameCache: "",
  treeDatas: [],
  groupTreeDatas: [], // 常用组
  leftTreeDatas: [], // 左侧树数据
  defaultExpandedKeys: [],
  companyId: "1",
  companyList: [],
  hasRight: 0
};



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/browser/propType.js